<template>
    <div class="select-input-wrapper">
      <div class="dropdown" :class="{ show: dropdownOpen }">
        <button
          class="form-control d-flex justify-content-between align-items-center"
          @click="toggleDropdown"
          ref="dropdownButton"
        >
          <span>{{ displayValue }}</span>
          <b-icon icon="chevron-down"></b-icon>
        </button>
  
        <div
          class="dropdown-menu show w-100 p-0"
          v-if="dropdownOpen"
          style="max-height: 300px; overflow-y: auto; position: absolute; top: 100%; left: 0; z-index: 1000;"
        >
          <div class="search-wrapper sticky-top bg-white" style="z-index: 20;">
            <div class="p-2">
              <input
                type="text"
                class="form-control"
                v-model="searchQuery"
                :placeholder="$t('search')"
              />
            </div>
          </div>
  
          <div
            v-for="option in filteredOptions"
            :key="option.id"
            class="dropdown-item"
            @click="selectOption(option)"
          >
            {{ option[optionLabel] || 'Unnamed' }}
          </div>
  
          <div v-if="!filteredOptions.length" class="dropdown-item disabled">
            {{ $t('no-results') }}
          </div>
        </div>
      </div>
  
      <small v-if="error" class="text-danger">{{ $t('field-required') }}</small>
    </div>
  </template>
  
  <script>
export default {
    name: "SelectSearch",
    props: {
      value: {
        type: [Object, Array],
        default: null,
      },
      options: {
        type: Array,
        default: () => [],
      },
      optionLabel: {
        type: String,
        default: "name",
      },
      nullLabel: {
        type: String,
        default: "None",
      },
      error: Boolean,
      disableNoneSelectedAlert: Boolean,
      hideSelected: Boolean,
    },
    data() {
      return {
        dropdownOpen: false,
        searchQuery: "",
      };
    },
    computed: {
      filteredOptions() {
        return this.options.filter((opt) => {
          const label = opt[this.optionLabel] || "";
          return label.toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      },
      displayValue() {
        if (Array.isArray(this.value)) {
          return this.value.length > 0
            ? `${this.value.length} selected`
            : this.nullLabel;
        } else if (this.value && typeof this.value === "object") {
          return this.value[this.optionLabel] || this.nullLabel;
        }
        return this.nullLabel;
      },
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectOption(option) {
            if (Array.isArray(this.value)) {
                const newValue = [...this.value];
                const index = newValue.findIndex((item) => item.id === option.id);
                if (index > -1) {
                newValue.splice(index, 1);
                } else {
                newValue.push(option);
                }
                this.$emit("input", newValue);
            } else {
                this.$emit("input", option);
            }
            this.dropdownOpen = false;  
            this.searchQuery = "";
        },
         handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
            this.dropdownOpen = false;
            }
      },
    },
    mounted() {
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickOutside);
    },
};
</script>
  
<style scoped lang="scss">
@import "src/styles/components/selectsearch.scss";
</style>
  